import { COMMVARIETY } from "./action";

const initialState = {
  commListVar: [],
  commVarList: [],
  varietyCreated: {},
  selectedVariety: {},
  varietyUpdated: {}
};

export default function commVarReducer(state = initialState, action) {
  switch (action.type) {
    case COMMVARIETY.getCommVarietyList.success:
      return {
        ...state,
        commVarList: action.data,
        varietyCreated: {},
        varietyUpdated: {}
      };
    case COMMVARIETY.getCommList.success:
      return {
        ...state,
        commListVar: action.data,
        varietyCreated: {},
        varietyUpdated: {}
      };
    case COMMVARIETY.create.success:
      return {
        ...state,
        varietyCreated: action.data
      };
    case COMMVARIETY.edit.success:
      return {
        ...state,
        selectedVariety: action.data
      };
    case COMMVARIETY.update.success:
      return {
        ...state,
        varietyUpdated: action.data
      };
    case COMMVARIETY.delete.success:
      return {
        ...state,
        commVarList: state.commVarList.filter(
          comm => comm.id !== action.data.id
        )
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/commvarieties/reducer.js